import React from 'react';
import PropType from 'prop-types';
import ReactHighcharts from 'react-highcharts';

class GenderChart extends React.Component {
  render() {
    const config = {
      chart: {
        type: 'bar'
      },
      title: {
        text: this.props.title
      },
      subtitle: {
        text: 'including patients documented as deceased',
      },
      xAxis: {
        categories: this.props.categories
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Total patients'
        }
      },
      legend: {
        reversed: true
      },
      plotOptions: {
        series: {
          stacking: 'normal'
        },
        bar: {
          dataLabels: {
            enabled: true,
            align: 'center',
          },
          enableMouseTracking: false
        },
      },
      // reverse in order to display it in the right order
      series: this.props.series
    };

    return <ReactHighcharts config={config}/>;
  }
}

GenderChart.propTypes = {
  data: PropType.array.isRequired,
};

export default GenderChart;


// WEBPACK FOOTER //
// ./src/views/Statistics/Gender/GenderChart.js